import React from "react";
import {
  Button,
  DatePicker,
  Dropdown,
  Form,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
} from "rsuite";
import CustomDropdown from "../../../components/CustomDropdown";
import { useState } from "react";
import DateDropdown from "./DateDropdown";

export function PrimaryTraveler({ data, onChange, errors, tour_booking_id }) {
  console.log(tour_booking_id, "datadddddd");
  const [allergies, setAllergies] = useState("No");
  const [specialMeal, setSpecialMeal] = useState("");
  const [mobility, setMobility] = useState("No");
  return (
    <>
      <div className="card containerd w-75 mb-2">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Primary Traveler's Personal Information</h2>
        </div>
        <div className="card-body p-3">
          <Form.Group>
            <Input
              className="mb-2"
              title={"Name of Trip"}
              label={"Name of Trip"}
              placeholder={"Name of Trip"}
              type={"text"}
              value={data?.name_of_trip}
              // onChange={(value) => onChange("name_of_trip", value)}
            />
          </Form.Group>

          {data?.booking_number?.length > 0 && (
            <Form.Group>
              <Input
                className="mb-2"
                title={"Booking #"}
                label={"Booking #"}
                placeholder={"Booking #"}
                value={data?.booking_number}
                // onChange={(value) => onChange("booking_number", value)}
                type={"text"}
              />
            </Form.Group>
          )}
          {!tour_booking_id && (
            <div
              style={{
                backgroundColor: "#fae8dc",
                // backgroundColor: "#f2f2f2",
                // margin: "10px 0",
                padding: "10px",
                border: "1.5px solid rgba(242, 89, 38)",
                marginBottom: "20px",
                borderRadius: "5px",
              }}
            >
              <Form.Group>
                <DateDropdown
                  id={data?.tour_uuid}
                  onChange={onChange}
                  dates={
                    data?.datesAndCities ? data?.datesAndCities : undefined
                  }
                />
                {errors?.datesAndCities && (
                  <Form.ErrorMessage show={errors?.datesAndCities}>
                    {errors?.datesAndCities}
                  </Form.ErrorMessage>
                )}
              </Form.Group>
              <Form.Group>
                <Input
                  id="homeDepartureCity"
                  name="homeDepartureCity"
                  placeholder="Home Departure City"
                  value={data?.home_departure_city}
                  onChange={(e) => onChange("home_departure_city", e)}
                />
                {errors?.home_departure_city && (
                  <Form.ErrorMessage show={errors?.home_departure_city}>
                    {errors?.home_departure_city}
                  </Form.ErrorMessage>
                )}
              </Form.Group>
              <Form.Group>
                <InputNumber
                  className="w-100"
                  min={1}
                  max={100}
                  value={data?.number_of_passengers}
                  placeholder="Passenger Number"
                  onChange={(e) => {
                    onChange("number_of_passengers", e);
                    if (e > 1) {
                      onChange("companion", "no");
                    }
                  }}
                />
                {errors?.number_of_passengers && (
                  <Form.ErrorMessage show={errors?.number_of_passengers}>
                    {errors?.number_of_passengers}
                  </Form.ErrorMessage>
                )}
                {/* radio */}
                {data?.number_of_passengers == 1 ? (
                  <div className="px-1">
                    <RadioGroup
                      name="radioList"
                      inline
                      value={data?.companion}
                      onChange={(value) => onChange("companion", value)}
                      className="d-flex justify-content-between align-items-center"
                    >
                      if single, are you looking for a travel companion
                      <Radio value="yes">yes</Radio>
                      <Radio value="no">no</Radio>
                    </RadioGroup>
                  </div>
                ) : null}
                {/* ll} */}
              </Form.Group>

              {/* Contact */}
              <Form.Group>
                <Input
                  id="contact"
                  name="contact"
                  value={data?.contact}
                  placeholder="Contact Number "
                  onChange={(e) => onChange("contact", e)}
                />
                {errors?.contact && (
                  <Form.ErrorMessage show={errors?.contact}>
                    {errors?.contact}
                  </Form.ErrorMessage>
                )}
              </Form.Group>
              {/* Details */}
              <Form.Group>
                <Input
                  value={data?.detail}
                  id="detail"
                  name="detail"
                  placeholder="Any other information that you would like to share? "
                  as="textarea"
                  rows={3}
                  onChange={(e) => onChange("detail", e)}
                />

                {errors?.detail && (
                  <Form.ErrorMessage show={errors?.detail}>
                    {errors?.detail}
                  </Form.ErrorMessage>
                )}
              </Form.Group>
            </div>
          )}
          <Form.Group>
            <Input
              // className="mb-2"
              id="full_name"
              name="full_name"
              title={"Full Name as it appears on your passport"}
              label={"Full Name as it appears on your passport"}
              placeholder={"Full Name as it appears on your passport"}
              type={"text"}
              value={data?.full_name}
              onChange={(value) => onChange("full_name", value)}
            />
            {errors?.full_name && (
              <Form.ErrorMessage show={errors?.full_name}>
                {errors?.full_name}
              </Form.ErrorMessage>
            )}
          </Form.Group>

          {/* {!errors?.homeDepartureCity && ( */}
          {/* {true && (
            <Form.ErrorMessage show={errors?.homeDepartureCity}>
              {"errors?.homeDepartureCity"}
            </Form.ErrorMessage>
          )} */}

          <Form.Group>
            <Input
              // className="mb-2"
              id="passport_number"
              name="passport_number"
              title={"Passport Number"}
              label={"Passport Number"}
              placeholder={"Passport Number"}
              type={"text"}
              value={data?.passport_number}
              onChange={(value) => onChange("passport_number", value)}
            />
            {errors?.passport_number && (
              <Form.ErrorMessage show={errors?.passport_number}>
                {errors?.passport_number}
              </Form.ErrorMessage>
            )}
          </Form.Group>

          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Passport expiry date</label> */}
            <DatePicker
              oneTap
              block
              format="yyyy/MM/dd"
              label={"Passport Expiry Date"}
              value={
                data?.passport_expiry_date
                  ? data?.passport_expiry_date
                  : undefined
              }
              onChange={(value) => onChange("passport_expiry_date", value)}
            />

            {errors?.passport_expiry_date && (
              <Form.ErrorMessage show={errors?.passport_expiry_date}>
                {errors?.passport_expiry_date}
              </Form.ErrorMessage>
            )}
          </Form.Group>
          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Passport expiry date</label> */}
            <Input
              // className="mb-2"
              id="nationality"
              name="nationality"
              title={"Nationality"}
              label={"Nationality"}
              placeholder={"Nationality"}
              type={"text"}
              value={data?.nationality}
              onChange={(value) => onChange("nationality", value)}
            />
            {errors?.nationality && (
              <Form.ErrorMessage show={errors?.nationality}>
                {errors?.nationality}
              </Form.ErrorMessage>
            )}
          </Form.Group>
          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <DatePicker
              oneTap
              block
              format="yyyy/MM/dd"
              label={"Date of Birth"}
              value={data?.date_of_birth ? data?.date_of_birth : undefined}
              onChange={(value) => onChange("date_of_birth", value)}
            />

            {errors?.date_of_birth && (
              <Form.ErrorMessage show={errors?.date_of_birth}>
                {errors?.date_of_birth}
              </Form.ErrorMessage>
            )}
          </Form.Group>
        </div>
      </div>
      <div className="card containerd mb-2 w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Primary Traveler's Address & Contact Information</h2>
        </div>
        <div className="card-body p-3 ">
          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Input
              // className="mb-2"
              id="full_street_address"
              name="full_street_address"
              title={"Full Street Address"}
              label={"Full Street Address"}
              placeholder={"Full Street Address"}
              type={"text"}
              value={data?.full_street_address}
              onChange={(value) => onChange("full_street_address", value)}
            />
            {errors?.full_street_address && (
              <Form.ErrorMessage show={errors?.full_street_address}>
                {errors?.full_street_address}
              </Form.ErrorMessage>
            )}
          </Form.Group>

          {/* <CustomDropdown
            title={"City"}
            col={"col-lg-12"}
            showTitle
            hide
            onChange={(value) => onChange("city", value)}
          /> */}
          <Input
                  id="city"
                  name="City"
                  placeholder="City"
                  value={data?.City}
                  onChange={(e) => onChange("city", e)}
                />
          {errors?.city && (
            <Form.ErrorMessage show={errors?.city}>
              {errors?.city}
            </Form.ErrorMessage>
          )}

          <style>
            {`
                    .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
        width: 100% !important;
      }
    `}
          </style>
          <Form.Group>
            <br />

            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Dropdown
              id="country"
              name="country"
              menuStyle={{ overflowY: "scroll", width: "100%" }}
              style={{ padding: "0.5rem 0", width: "100%" }}
              trigger={["click"]}
              title={data?.country ? "Country : " + data?.country : "Country"}
            >
              {["Canada", "United States"].map((ele) => (
                <Dropdown.Item onClick={() => onChange("country", ele)}>
                  {ele}
                </Dropdown.Item>
              ))}
            </Dropdown>
            {errors?.country && (
              <Form.ErrorMessage show={errors?.country}>
                {errors?.country}
              </Form.ErrorMessage>
            )}
          </Form.Group>

          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Input
              // className="mb-2"
              id="province_or_state"
              name="province_or_state"
              title={"Province/State"}
              label={"Province/State"}
              placeholder={"Province/State"}
              type={"text"}
              value={data?.province_or_state}
              onChange={(value) => onChange("province_or_state", value)}
            />
            {errors?.province_or_state && (
              <Form.ErrorMessage show={errors?.province_or_state}>
                {errors?.province_or_state}
              </Form.ErrorMessage>
            )}
          </Form.Group>
          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Input
              // className="mb-2"
              id="postal_code_or_zip_code"
              name="postal_code_or_zip_code"
              title={"Postal Code/Zip Code"}
              label={"Postal Code/Zip Code"}
              placeholder={"Postal Code/Zip Code"}
              type={"text"}
              value={data?.postal_code_or_zip_code}
              onChange={(value) => onChange("postal_code_or_zip_code", value)}
            />
            {errors?.postal_code_or_zip_code && (
              <Form.ErrorMessage show={errors?.postal_code_or_zip_code}>
                {errors?.postal_code_or_zip_code}
              </Form.ErrorMessage>
            )}
          </Form.Group>
          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Input
              // className="mb-2"
              id="email"
              name="email"
              title={"Your Email Address"}
              label={"Your Email Address"}
              placeholder={"Your Email Address"}
              type={"text"}
              value={data?.email}
              onChange={(value) => onChange("email", value)}
            />
            {errors?.email && (
              <Form.ErrorMessage show={errors?.email}>
                {errors?.email}
              </Form.ErrorMessage>
            )}
          </Form.Group>
          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Input
              // className="mb-2"
              id="phone_number"
              name="phone_number"
              title={"Your Phone Number"}
              label={"Your Phone Number"}
              placeholder={"Your Phone Number"}
              type={"text"}
              value={data?.phone_number}
              onChange={(value) => onChange("phone_number", value)}
            />
            {errors?.phone_number && (
              <Form.ErrorMessage show={errors?.phone_number}>
                {errors?.phone_number}
              </Form.ErrorMessage>
            )}
          </Form.Group>
          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Input
              // className="mb-2"
              id="emergency_contact_name"
              name="emergency_contact_name"
              title={"Emergency Contact Name"}
              label={"Emergency Contact Name"}
              placeholder={"Emergency Contact Name"}
              type={"text"}
              value={data?.emergency_contact_name}
              onChange={(value) => onChange("emergency_contact_name", value)}
            />
            {errors?.emergency_contact_name && (
              <Form.ErrorMessage show={errors?.emergency_contact_name}>
                {errors?.emergency_contact_name}
              </Form.ErrorMessage>
            )}
          </Form.Group>

          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Input
              // className="mb-2"
              id="emergency_contact_number"
              name="emergency_contact_number"
              title={"Emergency Contact Phone Number"}
              label={"Emergency Contact Phone Number"}
              placeholder={"Emergency Contact Phone Number"}
              type={"text"}
              value={data?.emergency_contact_number}
              onChange={(value) => onChange("emergency_contact_number", value)}
            />
            {errors?.emergency_contact_number && (
              <Form.ErrorMessage show={errors?.emergency_contact_number}>
                {errors?.emergency_contact_number}
              </Form.ErrorMessage>
            )}
          </Form.Group>
          <Form.Group>
            {/* <label style={{ fontSize: 14 }}>Date of Birth</label> */}
            <Input
              // className="mb-2"
              id="emergency_contact_email"
              name="emergency_contact_email"
              title={"Emergency Contact Email Address"}
              label={"Emergency Contact Email Address"}
              placeholder={"Emergency Contact Email Address"}
              type={"text"}
              value={data?.emergency_contact_email}
              onChange={(value) => onChange("emergency_contact_email", value)}
            />
            {errors?.emergency_contact_email && (
              <Form.ErrorMessage show={errors?.emergency_contact_email}>
                {errors?.emergency_contact_email}
              </Form.ErrorMessage>
            )}
          </Form.Group>
        </div>
      </div>
      <div className="card containerd w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2> Primary Traveler’s Allergies/Food Preference/Mobility</h2>
        </div>
        <div className="card-body p-3 ">
          <label style={{ fontSize: 14, marginBottom: 10 }}>
            Do You have food allergies?
          </label>
          <RadioGroup
            name="sharingOption"
            onChange={(value) => {
              if (value == "No") {
                setAllergies("No");
                onChange("food_allergies", "No");
              } else {
                setAllergies("Yes");
                onChange("food_allergies", "");
              }
            }}
            defaultValue={data?.food_allergies ? data?.food_allergies : "No"} // Set the default value to 'No' or 'Yes' based on your requirement
          >
            <Radio value="Yes">Yes</Radio>
            <Radio value="No">No</Radio>
          </RadioGroup>

          {allergies == "Yes" && (
            <Input
              // className="mb-2"
              as="textarea"
              rows={3}
              placeholder="Please list your food allergies"
              value={data?.food_allergies}
              onChange={(value) => onChange("food_allergies", value)}
            />
          )}
          <style>
            {`
                    .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
        width: 100% !important;
      }
    `}
          </style>
          <Dropdown
            menuStyle={{ overflowY: "scroll", width: "100%" }}
            style={{ padding: "0.5rem 0", width: "100%" }}
            trigger={["click"]}
            title={
              "Do you have special meal requirements? " + ` ${specialMeal}`
            }
          >
            {["No", "Vegan", "Vegetarian", "Celiac", "Other"].map((ele) => (
              <Dropdown.Item
                onClick={() => {
                  if (ele == "Other") {
                    setSpecialMeal("Other");
                    onChange("special_meal_requirements", "");
                  } else {
                    setSpecialMeal(ele);
                    onChange("special_meal_requirements", ele);
                  }
                }}
              >
                {ele}
              </Dropdown.Item>
            ))}
          </Dropdown>

          {specialMeal == "Other" && (
            <Input
              as="textarea"
              // className="mb-2"
              title={"Other special meal requirements"}
              label={"Other special meal requirements"}
              placeholder={"Other special meal requirements"}
              value={data?.special_meal_requirements}
              onChange={(value) => onChange("special_meal_requirements", value)}
            />
          )}
          <div>
            <label style={{ fontSize: 14, marginBottom: 10 }}>
              Do you have any mobility issues?
            </label>
            <RadioGroup
              name="mobility"
              onChange={(value) => {
                if (value == "No") {
                  setMobility("No");
                  onChange("mobility_issues", "No");
                } else {
                  setMobility("Yes");
                  onChange("mobility_issues", "");
                }
              }}
              defaultValue={
                data?.mobility_issues ? data?.mobility_issues : "No"
              } // Set the default value to 'No' or 'Yes' based on your requirement
            >
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </RadioGroup>
          </div>
          {mobility == "Yes" && (
            <Input
              // className="mb-2"
              title={"please let us know what those are"}
              label={"please let us know what those are"}
              placeholder={"Please let us know what those are"}
              as="textarea"
              value={data?.mobility_issues}
              onChange={(value) => onChange("mobility_issues", value)}
            />
          )}
        </div>
      </div>
    </>
  );
}
